// TOP LEVEL IMPORT
import React from 'react';
// ANTD
import Table from 'antd/lib/table';
// COMPONENTS
import SectionHeader from 'components/text/SectionHeader';
import Button from 'components/common/Button';
// APOLLO
import { graphql } from 'react-apollo';
import { MOBILE_COLUMNS, FULL_SCREEN_COLUMNS } from './columns.js';
import recentInvoicesQuery from 'ApolloClient/Queries/recentInvoices';
// APOLLO
import client from 'ApolloClient/index.js';
import invoicesByOrgId from 'ApolloClient/Queries/invoicesByOrgId';
import Papa from 'papaparse';
import moment from 'moment';
// HELPERS
import CurrencyHelpers from 'lib/helpers/CurrencyHelpers';

const downloadFile = (data, exportFilename) => {
  let csvData = new Blob([data], { type: 'text/csv;charset=utf-8;' });
  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(csvData, exportFilename);
  } else {
    // In FF link must be added to DOM to be clicked
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(csvData);
    link.setAttribute('download', exportFilename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

class InvoicesTable extends React.PureComponent {
  state = {
    loading: false,
  };
  shapeData = ({ data, currencySymbol }) =>
    data.map(invoice => ({
      number: invoice.number,
      currency: invoice.currency,
      amount: CurrencyHelpers.centsToDollars(invoice.amount, {
        symbol: CurrencyHelpers.getCurrencySymbol(invoice.currency || 'USD'),
      }),
      clientName: `${invoice.client.firstName} ${invoice.client.lastName}`,
      discountAmount: CurrencyHelpers.centsToDollars(invoice.discountAmount, {
        symbol: CurrencyHelpers.getCurrencySymbol(invoice.currency || 'USD'),
      }),
      sent: invoice.sentAt && moment(invoice.sentAt).format('M/D/YYYY hh:mma'),
      paid: invoice.paidAt && moment(invoice.paidAt).format('M/D/YYYY hh:mma'),
      due: invoice.due && moment(invoice.due).format('M/D/YYYY hh:mma'),
      clientEmail: invoice.client.email,
      clientId: invoice.clientId,
      salesTaxPercentage: invoice.salesTax && `${invoice.salesTax}%`,
      salesTax: CurrencyHelpers.centsToDollars(invoice.amount * (invoice.salesTax / 100), {
        symbol: CurrencyHelpers.getCurrencySymbol(invoice.currency || 'USD'),
      }),
      organizationId: invoice.organization._id,
    }));

  generateCSV = data => {
    let cleanData = this.shapeData({ data });
    let dataSource = Papa.unparse(cleanData, { header: true });
    downloadFile(dataSource, 'invoices-data.csv');
    this.setState({ loading: false });
  };

  onDownloadInvoices = async () => {
    this.setState({ loading: true });
    console.log('download all');
    let response = await client.query({
      query: invoicesByOrgId,
      variables: {
        organizationId: this.props.currentUser.profile.organizationId,
      },
    });
    console.log(response.data.invoicesByOrgId);
    this.generateCSV(response.data.invoicesByOrgId);
  };

  render() {
    const { recentInvoicesQuery, windowWidth } = this.props;
    return (
      <div style={{ marginTop: 25 }}>
        <div style={{ position: 'relative' }}>
          <SectionHeader>Recent Invoices</SectionHeader>
          <div style={{ position: 'absolute', right: 0, top: 0 }}>
            <Button loading={this.state.loading} type="dashed" icon="download" onClick={this.onDownloadInvoices}>
              Download All Invoices
            </Button>
          </div>
        </div>

        <Table
          style={{ width: '100%' }}
          rowKey={record => record._id}
          defaultPageSize={5}
          loading={recentInvoicesQuery.loading}
          pagination={{
            defaultPageSize: 5,
          }}
          columns={windowWidth < 789 ? MOBILE_COLUMNS : FULL_SCREEN_COLUMNS}
          dataSource={recentInvoicesQuery.recentInvoices}
        />
      </div>
    );
  }
}

export default graphql(recentInvoicesQuery, { name: 'recentInvoicesQuery' })(InvoicesTable);



// WEBPACK FOOTER //
// ./src/routes/app-home/InvoicesTable/index.js